import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mi0508',
    ecrans: ['00-2'],
    params: ['id', 'cleintref', 'stamnetab']
});
